<template>
	<div  v-loading="loading">
		<el-dialog  title="打印订单" :visible.sync="dialogVisible" @close="close" :fullscreen="true" top="30vh" >
			<div style="width: 90%;margin-left: 5%;margin-bottom: 20px;" >
				<el-button size="mini"  v-print="printObj"
				      type="primary"><i class="el-icon-edit"></i>打印</el-button>
			</div>
			<div style="">
				<div id="printTest">
					<!-- <div  >
						<el-form label-width="80px">
							<el-row>
								<el-col :span="24">
									<el-form-item label="详细地址">
										{{form.address}}
									</el-form-item>
								</el-col>
								<el-col :span="12">
									<el-form-item label="联系人">
										{{form.link_name}}
									</el-form-item>
								</el-col>
								<el-col :span="12">
									<el-form-item label="联系电话">
										{{form.link_mobile}}
									</el-form-item>
								</el-col>
								<el-col :span="12">
									<el-form-item label="订单金额">
										{{form.link_mobile}}
									</el-form-item>
								</el-col>
							</el-row>
						</el-form>
					</div> -->
					
					<table  class="table"  border="1" cellspacing="0">
					  <thead>
						<tr>
							<td colspan="6" style="padding: 5px;">
								<span style="font-weight: 700;font-size: 18px;">发货者：徐盐荣百货(注:现金全场享折扣 10%）</span>
							</td>
						</tr>
						<tr>
							<td colspan="6" style="padding: 5px;">
								<span>TEL:0628868885</span>  <span style="margin-left: 20px;">地址：petrovac</span>
							</td>
						</tr>
						
						<tr>
							<td colspan="6" style="padding: 5px;">
								<div style="width: 25%;float: left;text-align: center;">
									<img src="../../assets/img/qrcode1.jpg" style="height: 150px;"/>
								</div>
								<div style="width: 75%;float: left;line-height: 50px;">
									<div style="width: 50%;float: left;height: 35px;">订单号：{{order.order_id}}</div>
									<div style="width: 50%;float: left;height: 35px;">日期:{{order.create_time}}</div>
									<div style="width: 50%;float: left;height: 35px;">订货人：{{form.link_name}}</div>
									<div style="width: 50%;float: left;height: 35px;">联系电话:{{form.link_mobile}}</div>
									<div style="width: 50%;float: left;height: 35px;">操作人：{{user_name}}</div>
									<div style="width: 50%;float: left;height: 35px;">付款方式：{{form.pay}}</div>
									<div style="width: 100%;float: left;">地址:{{form.address}}</div>
									
								</div>
							</td>
						</tr>
						
						<tr >
						  <!-- <td style="padding: 10px;">商品缩略图</td> -->
						  <td style="padding: 3px;">序号</td>
						  <td style="padding: 3px;text-align: left;width:50%">商品名</td>
						  <td style="padding: 3px;">数量</td>
						  <td style="padding: 3px;">单价</td>
						  <td style="padding: 3px;">合计</td>
						  <td style="padding: 3px;">备注</td>
						</tr>
					  </thead>
					  <tbody >
						<tr v-for="(item,index) of tableData" >
							<!-- <td>
								<div style="padding: 10px;text-align: center;">
									<img :src="item.img" style="width: 90px;height: 90px;"/>
								</div>
							</td> -->
							<td style="padding: 3px;">
								{{index+1}}
							</td>
							<td style="padding: 3px;text-align: left;">
								{{item.name}}:{{item.norms_name}}
							</td>
							<td style="padding: 3px;">
								{{item.goods_num}}
							</td>
							<td style="padding: 3px;">
								{{item.price}}
							</td>
							<td style="padding: 3px;">
									{{item.count_price}}
							</td>
							<td style="padding: 3px;">
								{{item.order}}
							</td>
						</tr>
						<tr>
							<td colspan="6" style="padding: 3px;text-align: right;">
								<span>总计：{{count_price}}</span>
							</td>
						</tr>
						<tr v-if="num_money!=''">
							<td colspan="1" style="padding: 3px;text-align: center;">
								<span>备注</span>
							</td>
							<td colspan="1" style="padding: 3px;text-align: left;">
								<span>{{form.yh_remark}}</span>
							</td>
							<td colspan="2" style="padding: 3px;text-align: right;">
								<span>{{count_price}}{{form.yh_money_fh}}{{form.yh_money_bl}}</span>
							</td>
							<td colspan="2" style="padding: 3px;text-align: right;">
								<span>总计：{{num_money}}</span>
							</td>
						</tr>
						
						<tr v-if="num_money1!=''">
							<td colspan="1" style="padding: 3px;text-align: center;">
								<span>备注</span>
							</td>
							<td colspan="1" style="padding: 3px;text-align: left;">
								<span>{{form.yh_remark1}}</span>
							</td>
							<td colspan="2" style="padding: 3px;text-align: right;">
								<span v-if="num_money!=''">{{num_money}}</span><span v-if="num_money==''">{{count_price}}</span><span>{{form.yh_money_fh1}}{{form.yh_money_bl1}}</span>
							</td>
							<td colspan="2" style="padding: 3px;text-align: right;">
								<span>总计：{{num_money1}}</span>
							</td>
						</tr>
						
					  </tbody>
					</table>
				</div>
			</div>
			<div style="height:30px"></div>
		</el-dialog>
	</div>
</template>
<script>
import Vue from 'vue';
import Print from 'vue-print-nb'
Vue.use(Print);
export default{
	name:'Edit',
	props:{
		id:String,
		type:String
	},
	data(){
		return {
			dialogVisible:true,
			data:[],
			content_show:false,
			loading: false,
			search:{
				order_id:"",
			},
			form:{
				address:"",
				link_name:"",
				link_mobile:"",
				pay:""
			},
			order:{
				order_id:"",
				create_time:"",
			},
			user_name:"",
			count_price:"",
			tableData:[],
			headerObj:{
				token:sessionStorage.getItem("token")
			},
			printObj:{
			    id:"printTest",
			    popTitle:"",
			    extraHead: '<meta http-equiv="Content-Language"content="zh-cn"/>,<style>  #printId { width: 100%;  } <style>'
			},
			num_money:"",
			num_money1:"",
			nameList: ["香蕉","苹果","梨子","葡萄","哈密瓜","车厘子","草莓","榴莲","石榴","黄瓜","圣女果"],
		}
	},
	methods:{
		print(){
			window.print();
		},
		async handleEdit(index,row){
			var url="/index/OrderGoods/Edit";
			var res=await this.$post(url,row)
			if(res.errCode=="0"){
				this.$error(res,this);
				return;
			}
			this.$success(res,this);
			this.GetInfo();
		},
		GoodsNumEdit(row){
			if(row.goods_num==undefined){
				row.goods_num=1;
			}
			row.count_price=(row.goods_num*row.price).toFixed(2);
		},
		close(){
			this.dialogVisible=false
			this.$emit("close")
		},
		handleClick(tab, event){
		},
		async GetInfo(){
			var res=await this.$get("/index/OrderGoods/GetList",{"order_id":this.search.order_id})
			this.tableData=res.result.data;
			this.count_price=res.result.count_price
			this.user_name=res.result.user_name;
			var res=await this.$get("/index/Order/Find",{"uuid":this.search.order_id})
			this.order={
				order_id:res.result['uuid'],
				create_time:res.result['create_time']
			}
			this.form={
				"address":res.result['address'],
				"link_name":res.result['link_name'],
				"link_mobile":res.result['link_mobile'],
				"pay":res.result['pay'],
				"yh_remark":res.result['yh_remark'],
				"yh_money_fh":res.result['yh_money_fh'],
				"yh_money_bl":res.result['yh_money_bl'],
				"yh_remark1":res.result['yh_remark1'],
				"yh_money_fh1":res.result['yh_money_fh1'],
				"yh_money_bl1":res.result['yh_money_bl1'],
				"uuid":res.result['uuid']
			};
			var money=0;
			if(this.form.yh_money_fh!="" && this.form.yh_money_bl!="" && this.form.yh_money_fh!=null && this.form.yh_money_bl!=null){
				money=eval(this.count_price+this.form.yh_money_fh+this.form.yh_money_bl).toFixed(2);
				this.num_money=money;
			}
			var money1=0;
			if(this.form.yh_money_fh1!="" && this.form.yh_money_bl1!="" && this.form.yh_money_fh1!=null && this.form.yh_money_bl1!=null){
				if(money==0){
					money1=eval(this.count_price+this.form.yh_money_fh1+this.form.yh_money_bl1).toFixed(2);
				}else{
					money1=eval(money+this.form.yh_money_fh1+this.form.yh_money_bl1).toFixed(2);
				}
				this.num_money1=money1
			}
			
		},
		async tijiao(){
			var url="/index/Order/Edit";
			var res=await this.$post(url,this.form)
			this.$success(res,this);
		}
	},
	mounted(){
		
		if(this.id!=""){
			this.search.order_id=this.id
			this.GetInfo();
		} 
	}
}
</script>
<style scoped="scoped">
	/deep/ .el-dialog.is-fullscreen{
		margin-top:50px;
	}
	div{
		text-align: left;
	}
	.text{
		width: 80%;
	}
	
	.table{
		border:1px solid black;width: 100%;text-align: center;cellspacing:0;
		color:#666;
	}
	.table th {
		background-repeat:repeat-x;
		height:30px;
	}
	.table td,.table th{
		border:1px solid black;
		padding:0 1em 0;
	}
	.table tr.alter{
		background-color:#f5fafe;
	} 
</style>
